import React, { useEffect, useState } from 'react';

import './ListView.css';

function ListView(props) {

  const [totalCompanies, setTotalCompanies] = useState('-');
  const [totalAwards, setTotalAwards] = useState('-');
  const [top10, setTop10] = useState();

  useEffect(() => {
    // console.log('listView: props', props);
    setTotalCompanies(props.totalCompanies);
    setTotalAwards(props.totalAwards);
    setTop10(props.top10);
  }, [props]);

  return (
    <div>
      <div class="totalCompaniesAwards"> 
        <div>
          <b>{totalCompanies}</b>: TOTAL COMPANIES
        </div>
        <div>
          <b>{totalAwards}</b>: TOTAL AWARDS
        </div>
      </div>
      <div class="table">
        <div class="top10">
          <b>Top 10 companies</b>
        </div>
        <table size="sm" responsive>
          <thead>
            <tr>
              <th>Company</th>
              <th>Awards</th>
            </tr>
          </thead>
          <tbody>
            {top10 && top10.map(company => (<tr>
              <td>{company.companyName}</td>
              <td>{company.awards}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ListView;
